import polyglotI18nProvider from 'ra-i18n-polyglot';
import ru from '../i18n/ru';

const i18nProvider = polyglotI18nProvider(() => ru, 'ru');

export default i18nProvider